import Vue from 'vue';
import { isElectronContext } from './isElectron';

export function getScriptByBrand() {
  const isElectron = isElectronContext();
  if (isElectron) return;
  if (window.location.hostname.includes('instabet.mx')) {
    return 'https://static.zdassets.com/ekr/snippet.js?key=1aac1981-037c-4f9d-aff1-fd931ea17017';
  } else if (window.location.hostname.includes('instabet.net')) {
    return 'https://static.zdassets.com/ekr/snippet.js?key=c31dd5ca-3737-479e-be7e-025f41f37005';
  }

  // return 'https://static.zdassets.com/ekr/snippet.js?key=c31dd5ca-3737-479e-be7e-025f41f37005';
}
export function toggleChat(locale) {
  zE('webWidget', 'setLocale', locale);
  $zopim.livechat.window.toggle();
  //zE('webWidget', 'toggle'); // Yeni projede kullanılabilir, üstteki satırla aynı işi yapıyor.
  const chatBubble = document.getElementById('launcher');
  chatBubble.style.display = 'block';
}

export function create() {
  let currentScript = getScriptByBrand();
  window.zESettings = {
    webWidget: {
      color: {
        launcher: '#32ac26', // bubble color
        launcherText: '#ffffff', // icon color
      },
      chat: {
        connectOnPageLoad: false,
      },
      launcher: {
        chatLabel: {
          '*': ' ',
        },
      },
    },
  };
  if (currentScript && !document.getElementById('ze-snippet')) {
    let zendesk = document.createElement('script');
    zendesk.setAttribute('src', currentScript);
    zendesk.id = 'ze-snippet';
    zendesk.defer = true;
    document.head.appendChild(zendesk);
  }
  if (currentScript && window.zE) {
    zE('webWidget', 'show');
  }
}

export function hide() {
  if (window.zE) {
    zE('webWidget', 'hide');
  }
}

Vue.prototype.$zendeskController = {
  create,
  hide,
  toggleChat,
  getScriptByBrand,
};
